import React from "react";

function DollarIcon() {
  return (
    <svg
      width="15"
      height="25"
      viewBox="0 0 15 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 1.25V23.25M12.25 5.25H4.75C3.82174 5.25 2.9315 5.61875 2.27513 6.27513C1.61875 6.9315 1.25 7.82174 1.25 8.75C1.25 9.67826 1.61875 10.5685 2.27513 11.2249C2.9315 11.8813 3.82174 12.25 4.75 12.25H9.75C10.6783 12.25 11.5685 12.6187 12.2249 13.2751C12.8813 13.9315 13.25 14.8217 13.25 15.75C13.25 16.6783 12.8813 17.5685 12.2249 18.2249C11.5685 18.8813 10.6783 19.25 9.75 19.25H1.25"
        stroke="#039855"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DollarIcon;
